import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { Menu } from "antd";
import { navLinks } from "./navLinks";
import { Icon } from "@ant-design/compatible";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function SidebarItems({ collapsed, permission }) {
  const { SubMenu } = Menu;
  const location = useLocation();
  const [menuItem, setmenuItem] = useState("");

  useEffect(() => {
    setmenuItem(location.pathname.split("/").pop());
  }, [location]);

  const permissionArr = Object.keys(permission).filter(
    (key) => permission[key] === true
  );

  function hasPermission(obj) {
    let permissionGranted = false;

    if (obj.permission) {
      permissionGranted = permissionArr.find(
        (element) =>
          element === obj.permission || element === "sm_solution_access",
      );
      if (!permissionGranted) {
        switch (obj.permission) {
          case "sm_user_managment":
            permissionGranted = Boolean(permission?.sm_solution_access);
            break;
          default:
        }
      }
    } else {
      permissionGranted = true;
    }

    return permissionGranted;
  }

  function renderMenuItem(obj) {
    return (
      <Menu.Item key={obj.tooltip} data-test-id={obj?.testDataId}>
        <Link to={obj.link}>
          {obj.logo && <Icon component={obj.logo} style={{ margin: "0px" }} />}
          {obj.faIcon && (
            <FontAwesomeIcon className="anticon" icon={obj.faIcon} />
          )}
          <span>{obj.title}</span>
        </Link>
      </Menu.Item>
    );
  }

  function renderSubMenuItem(obj) {
    return (
      <SubMenu
        key={obj.tooltip}
        data-test-id={obj?.testDataId}
        title={
          <span>
            {obj.logo && (
              <Icon component={obj.logo} style={{ margin: "0px" }} />
            )}
            {obj.faIcon && (
              <FontAwesomeIcon className="anticon" icon={obj.faIcon} />
            )}
            <span>{obj.title}</span>
          </span>
        }
      >
        {nestedRoutes(obj.subMenu)}
      </SubMenu>
    );
  }

  function nestedRoutes(arr) {
    return arr.map((obj) => {
      if (hasPermission(obj)) {

        //For Generic/Marriott menu restrictions
        if(obj.platformType && obj.platformType !== process.env["REACT_APP_PLATFORM_TYPE"]){
          return;
        }

        if (obj.link) {
          return renderMenuItem(obj);
        } else if (obj.subMenu.length > 0) {
          return renderSubMenuItem(obj);
        } else {
          return renderMenuItem(obj);
        }
      }
    });
  }

  if (["bulk-user-creation", "user-create", "user-manager"].indexOf(menuItem) !== -1) {
    return (
      <div className="sidebar_ab">
        <Menu
          selectedKeys={[menuItem]}
          style={{ backgroundColor: "#3b6cb4", color: "#ffffff" }}
          mode="inline"
          theme="dark"
          inlineCollapsed={!collapsed}
        >
          {nestedRoutes(navLinks)}
        </Menu>
      </div>
    );
  } else {
    return (
      <div className="sidebar_ab">
        <Menu
          defaultSelectedKeys={["1"]}
          style={{ backgroundColor: "#3b6cb4", color: "#ffffff" }}
          mode="inline"
          theme="dark"
          inlineCollapsed={!collapsed}
        >
          {nestedRoutes(navLinks)}
        </Menu>
      </div>
    );
  }
}
